import { _, $, Backbone, Foundation, Radio } from "../../vendor";
import { Biscuit } from "../utils";
import InboomaBaseController from "./InboomaBaseController";

import Pricediscount from "../models/Pricediscount";
import Pricediscounts from "../collections/Pricediscounts";
//import Users from '../collections/Users'
// import Pricetariffs from '../collections/Pricetariffs'

import PricediscountsSidebarView from "../views/pricediscounts/PricediscountsSidebarView";
import ClientDiscountSidebarView from "../views/pricediscounts/ClientDiscountSidebarView";
import UserDiscountSidebarView from "../views/pricediscounts/UserDiscountSidebarView";
import NumberDiscountSidebarView from "../views/pricediscounts/NumberDiscountSidebarView";
import PricediscountsSortTabs from "../views/pricediscounts/PricediscountsSortTabs";
import ClientDiscountSortTabs from "../views/pricediscounts/ClientDiscountSortTabs";
import NumberDiscountSortTabs from "../views/pricediscounts/NumberDiscountSortTabs";
import UserDiscountSortTabs from "../views/pricediscounts/UserDiscountSortTabs";
import PricediscountsAccessBarView from "../views/pricediscounts/PricediscountsAccessBarView";
import PricediscountsView from "../views/pricediscounts/PricediscountsView";
import OffCanvasPricediscountsForm from "../views/pricediscounts/OffCanvasPricediscountsForm";
import ClientDiscountView from "../views/pricediscounts/ClientDiscountView";
import UserDiscountView from "../views/pricediscounts/UserDiscountView";
import NumberDiscountView from "../views/pricediscounts/NumberDiscountView";
//import User from '../models/User';

import PricediscountsViewTpl from "../templates/pricediscounts/PricediscountsTpl.html";
import LinksMap from "./ContingentsControllerAccessBarMap";

export default InboomaBaseController.extend({
  _template: PricediscountsViewTpl,
  _el: "#inb-c-main-pricediscounts",
  _channelName: "pricediscounts",

  /**
   * @routes /pricediscounts
   *         /pricediscounts:side_type opens different views of discount_types
   *         /pricediscounts:side_type:id highlight the pricediscount
   */
  index(side_type = false, id = null) {
    // this._resetOptions(options);
    /*  return new Promise(
            (resolve, reject) => {
*/
    // that.ready().then(function(){
    // @TODO if render

    /* if (typeof this._pricediscountsView != 'undefined'
                        && typeof this._pricediscountsView.unbindEvents == 'function') {
                        this._pricediscountsView.$el.empty();
                        this._pricediscountsView.stopListening();
                    }*/

    //       this.collection.resetFilters();
    console.log(side_type);
    if (!$(".inb-filtered-pricediscounts-count").length) {
      if (typeof side_type !== "undefined" || !side_type) {
        new PricediscountsView({
          collection: this.collection,
          el: this._el,
        });

        new PricediscountsSortTabs({
          collection: this.collection,
          model: Pricediscount,
        }).render();
        new PricediscountsAccessBarView({
          collection: this.collection,
          model: Pricediscount,
        }).render();
        new PricediscountsSidebarView({
          collection: this.collection,
          model: Pricediscount,
        }).render();
      } else {
        switch (side_type) {
          case "clientDiscount":
            new ClientDiscountView({
              collection: this.collection,
              el: this._el,
              id: id,
            });

            new ClientDiscountSortTabs({
              collection: this.collection,
              model: Pricediscount,
              id: id,
            }).render();

            new ClientDiscountSidebarView({
              collection: this.collection,
              model: Pricediscount,
              id: id,
            }).render();
            break;
          case "userDiscount":
            new UserDiscountView({
              collection: this.collection,
              el: this._el,
              id: id,
            });

            new UserDiscountSortTabs({
              collection: this.collection,
              model: Pricediscount,
              id: id,
            }).render();

            new UserDiscountSidebarView({
              collection: this.collection,
              model: Pricediscount,
              id: id,
            }).render();
            break;
          case "numberDiscount":
            new NumberDiscountView({
              collection: this.collection,
              el: this._el,
              id: id,
            });

            new NumberDiscountSortTabs({
              collection: this.collection,
              model: Pricediscount,
              id: id,
            }).render();

            new NumberDiscountSidebarView({
              collection: this.collection,
              model: Pricediscount,
              id: id,
            }).render();
            break;
          default:
            new PricediscountsView({
              collection: this.collection,
              el: this._el,
            });

            new PricediscountsSortTabs({
              collection: this.collection,
              model: Pricediscount,
            }).render();
            new PricediscountsSidebarView({
              collection: this.collection,
              model: Pricediscount,
            }).render();
        }
        new PricediscountsAccessBarView({
          collection: this.collection,
          model: Pricediscount,
        }).render();
      }

      $(".inb-filtered-pricediscounts-count").html(this.collection.models.length);

      /*  if (!this.widgetMode) {
                  this.app.trigger('change:view', 'pricediscounts', this._pricediscountsView);
              }*/
    }
    let mainMenu = document.getElementById("inb-main-menu");
    if (mainMenu !== undefined && mainMenu != null && mainMenu.querySelector(".l-contingents")) {
      mainMenu.querySelector(".l-contingents").classList.add("active");
    }
    //  })
    /* }).then();*/
  },

  /**
   * @routes /pricediscounts/add
   */
  pricediscountsForm(type = "client") {
    let model = new Pricediscount();
    new OffCanvasPricediscountsForm({ model: model, collection: this._collection, type: type });
  },

  /**
   * @routes /pricediscounts/help
   */
  pricediscountsHelp() {
    new Foundation.Reveal($(".inb-pricediscounts-help-modal")).open();
    $(document).on("closed.zf.reveal", function () {
      Backbone.history.navigate("pricediscounts");
      $(document).off("closed.zf.reveal");
    });
  },
  /**
   * @routes /pricediscounts/number_discount
   *
   */
  numberDiscount(id = null) {
    this.index("numberDiscount", id);
  },

  /**
   * @routes /pricediscounts/client_discount
   *
   */
  clientDiscount(id = null) {
    this.index("clientDiscount", id);
  },

  /**
   * @routes /pricediscounts/user_discount
   *
   */
  userDiscount(id = null) {
    this.index("userDiscount", id);
  },
});
